import { render, staticRenderFns } from "./TextareaV1.vue?vue&type=template&id=78653af2&scoped=true&"
import script from "./TextareaV1.vue?vue&type=script&lang=js&"
export * from "./TextareaV1.vue?vue&type=script&lang=js&"
import style0 from "./TextareaV1.vue?vue&type=style&index=0&id=78653af2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78653af2",
  null
  
)

export default component.exports